import React from 'react';
import { FiArrowUpRight, FiGithub, FiLinkedin, FiMapPin } from 'react-icons/fi';

export function Contact() {
  return <section className="contact" id="Contact">
    <div className="contact__orb" aria-hidden="true" />
    <p className="eyebrow">HAVE A PROJECT OR OPPORTUNITY?</p>
    <h2>Let’s build something<br/><em>worth remembering.</em></h2>
    <p>I’m open to full-stack and frontend-focused roles where product quality, performance, and thoughtful engineering matter.</p>
    <a className="contact__email" href="mailto:himanshu.singh5296@gmail.com">himanshu.singh5296@gmail.com <FiArrowUpRight /></a>
    <div className="contact__meta"><span><FiMapPin /> Ghaziabad, India</span><a href="https://github.com/Himanshu5296" target="_blank" rel="noreferrer"><FiGithub /> GitHub</a><a href="https://linkedin.com/in/himanshusingh52" target="_blank" rel="noreferrer"><FiLinkedin /> LinkedIn</a></div>
  </section>;
}
